<nb-card class="document-sheet">
  <nb-card-header class="header">
    <div class="header-left"></div>
    <div class="title" [class.red-title]="isMaintenanceContract">{{ sheetTitle | translate }}</div>
    <div class="header-actions">
      <span class="close-btn" (click)="close()">
        <i class="fa-light fa-x"></i>
      </span>
    </div>
  </nb-card-header>

  <nb-card-body class="body" *ngIf="doc && form">
    <form [formGroup]="form" class="form-group">

      <div class="form-field">
        <label>{{ 'documents.sheet.label' | translate }}</label>
        <input
          nbInput
          type="text"
          formControlName="title"
          fullWidth
          placeholder="-"
          (blur)="onTitleBlur()"
          (keydown)="onTitleKeydown($event)"
        />
      </div>

      <div class="form-field">
        <label>{{ 'documents.sheet.type' | translate }}</label>
        <div class="field-value">{{ doc.type || '-' }}</div>
      </div>

      <div class="form-field">
        <label>{{ 'documents.sheet.linked_to' | translate }}</label>
        <div class="field-value">{{ linkedTo }}</div>
      </div>

      <div class="form-field">
        <label>{{ 'documents.sheet.url' | translate }}</label>
        <div class="url-input-container">
          <input
            nbInput
            type="text"
            formControlName="link"
            fullWidth
            placeholder="-"
            [title]="form.get('link')?.value || ''"
            (focus)="onUrlFocus($event)"
            (blur)="onUrlBlur($event)"
          />
          @if (form.get('link')?.value) {
            <button type="button" class="url-link-icon" (click)="openUrl($event)" [title]="form.get('link')?.value">
              <fa-icon [icon]="faFileLines"></fa-icon>
            </button>
          }
        </div>
      </div>

      <ng-container *ngIf="isMaintenanceContract">

        <div class="form-field autocomplete-container">
          <label>{{ 'documents.sheet.company' | translate }}</label>
          <input
            nbInput
            type="text"
            formControlName="company"
            fullWidth
            placeholder="-"
            (input)="onCompanyInputChange($any($event.target).value)"
            (focus)="onCompanyInputFocus($any($event.target).value)"
            (blur)="onCompanyBlur()"
          />
          @if (filteredCorporates.length > 0) {
            <div class="autocomplete-dropdown">
              @for (name of filteredCorporates; track name) {
                <div class="autocomplete-item" (mousedown)="selectCorporate(name)">{{ name }}</div>
              }
            </div>
          }
        </div>

        <div class="form-field pb-2">
          <label>{{ 'documents.sheet.expiry_date' | translate }}</label>
          <div class="datepicker-field">
            <input
              nbInput
              class="date-input"
              [nbDatepicker]="expiryPicker"
              formControlName="expiry_date"
              (dateChange)="onDateChange($event, 'expiry_date')"
              placeholder="-"
              (click)="!expiryPicker.isShown && expiryPicker.show()"
            />
            <button
              type="button"
              class="datepicker-toggle"
              (click)="$event.preventDefault(); $event.stopPropagation(); expiryPicker.isShown ? expiryPicker.hide() : expiryPicker.show()"
            >
              <i class="fa-light fa-calendar"></i>
            </button>
          </div>
          <nb-datepicker #expiryPicker></nb-datepicker>
        </div>

        <div class="form-field">
          <label class="equipement-label">{{ 'documents.sheet.linked_equipments' | translate }}</label>
          <div class="equipment-input-container">
            <input
              nbInput
              type="text"
              [value]="doc.linked_equipment?.length ? doc.linked_equipment.length : '-'"
              readonly
              fullWidth
              style="cursor: pointer;"
              (click)="openLinkedEquipmentDialog()"
            />
            <span class="right-chevron" (click)="openLinkedEquipmentDialog()">
              <fa-icon [icon]="faChevronRight"></fa-icon>
            </span>
          </div>
        </div>

      </ng-container>
    </form>
  </nb-card-body>
</nb-card>
